let uuid = 0;
export function UniqueID(): number {
  uuid++;
  return uuid;
}
